// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__5FA9D","approved":"Status_approved__3SPqE","rejected":"Status_rejected__1eHA4","expired":"Status_expired__2-BVj","label":"Status_label__2ijLG"};